/** Shared reads. Commands, editable buffers and continuous streams are not assets. */
export enum LazyAsset {
  RuntimeInfo = 'runtime-info',
  CloudStatus = 'cloud-status',
  Capabilities = 'capabilities',
  CapabilitySummary = 'capability-summary',
  AssetCatalog = 'asset-catalog',
  IndexStatus = 'index-status',
  AssetStats = 'asset-stats',
  ProjectAssetMenu = 'project-asset-menu',
  Projects = 'projects',
  DiscoveredProjects = 'discovered-projects',
  Workspaces = 'workspaces',
  ProjectResources = 'project-resources',
  Skills = 'skills',
  Bookmarks = 'bookmarks',
  FavoriteSummaries = 'favorite-summaries',
  RagIndexes = 'rag-indexes',
  Activities = 'activities',
  IndexActivity = 'index-activity',
  Connections = 'connections',
  DeployProviders = 'deploy-providers',
  LlmFunding = 'llm-funding',
  Status = 'status',
  GitRepos = 'git-repos',
  GitBranches = 'git-branches',
  GitInvitations = 'git-invitations',
  GitOrgs = 'git-orgs',
  GitOrgRepos = 'git-org-repos',
}
